const getData = (state, selector) => {
  const data = state.YearGroups ? state.YearGroups : state
  return !data ? null : selector(data)
}

const getYearGroupsFetchingStatus = (state, id) =>
  getData(state, data => data.fetching)

const getYearGroups = state => getData(state, data => data.yearGroups)

export { getYearGroupsFetchingStatus, getYearGroups }
